import { IComment } from "interfaces/comment";
import { useReadComments } from "hooks/comments/useReadComments";

interface Result {
  loading: boolean;
  getProjectComments: () => Promise<IComment[]>;
}

export function useReadProjectComments(projectId: number): Result {
  const { loading, getComments } = useReadComments(`projects/${projectId}`);

  return {
    loading,
    getProjectComments: getComments
  };
}
